const config = {
    // apiUrl: 'https://hml-cashback.teknisa.com/backend_giraffas/index.php/'
    // apiUrl: 'https://dev-integracoes.teknisa.com/backend_giraffas/service/index.php/'
    // apiUrl: 'https://marcossouza2.zeedhi.com/workfolder/fidelity-api/backend/service/index.php/'
    // apiUrl: 'https://marcossouza2.zeedhi.com/workfolder/fidelity-api-0-6-0/backend/service/index.php/'
    // apiUrl: 'https://dev-integracoes.teknisa.com/backend_mundoanimal/service/index.php/'
    // apiUrl: 'https://heitorcarvalho2.zeedhi.com/workfolder/fidelity-api/backend/service/index.php/',
    // isSaas: "false"
    apiUrl: '<>CASHBACK_API_URL<>',
    isSaas: '<>IS_SAAS<>'
}

export { config }
